import { NavLink } from "react-router";

import { Card, Typography } from "@digital-services/ui";

import { ApplicationJsonModel } from "@application/model/ApplicationJsonModel";

import { AppEnv } from "./AppEnv";

interface Props {
  applicationData: ApplicationJsonModel;
}

export const ApplicationTile = (props: Props) => {
  const { id, logoUrl, frontendUrl, name, appEnv } = props.applicationData;

  return (
    <NavLink
      to={frontendUrl}
      key={"nav_" + id}
      style={{ color: "black", textDecoration: "none" }}
      target="_blank"
      data-testid={`application-link-${id}`}
    >
      <Card
        className="grid h-32 w-60 grid-cols-1 place-content-center place-items-center gap-3"
        data-testid={`application-tile-card-${id}`}
      >
        <img
          src={logoUrl}
          data-testid="application-logo-image"
          alt="app-tile-img"
        />
        <Typography variant="smallTitle">{name}</Typography>
        {appEnv ? <AppEnv value={appEnv} /> : null}
      </Card>
    </NavLink>
  );
};
